<template>
  <div>
    <mheader></mheader>
    <!-- <article-category></article-category> -->
    <div class="breadcrumb">
      <router-link to="/">Home</router-link> / Article List
      <!-- <a-breadcrumb>
        <a-breadcrumb-item><router-link to="/">Home</router-link></a-breadcrumb-item>
        <a-breadcrumb-item>Article List</a-breadcrumb-item>
      </a-breadcrumb> -->
    </div>
    <!-- <article-list-comp :articleList="articleList"></article-list-comp> -->
    <article-list-item :articleList="articleList"></article-list-item>
    <mfooter></mfooter>
  </div>
</template>

<script>
import axios from '@/api';
import Mheader from '@/components/Mheader';
import Mfooter from '@/components/Mfooter';
import ArticleListComp from '@/components/ArticleListComp';
import ArticleListItem from '@/components/ArticleListItem';
// import ArticleCategory from '@/components/ArticleCategory';

export default {
  name: 'ArticleList',
  components: {
    Mheader,
    Mfooter,
    ArticleListComp,
    ArticleListItem,
    // ArticleCategory
  },
  data() {
    return {
      articleList: []
    }
  },
  mounted() {
    axios.getArticleList().then(res => {
      this.articleList = res.data.list;
    });
  }
}
</script>

<style scoped>
.breadcrumb {
  margin-top: 3rem;
  color: #ccc;
}
.breadcrumb a {
  color: #999;
}
.breadcrumb a:hover {
  color: #1890ff;
}
</style>
